// Сверка верх↔низ на странице «Новая заявка» — клик-навигация между блоками
// «Результат распознавания» и «Позиции». Вынесено из NewRequestPage (≤500 строк).

/**
 * Подсвечивает якорь-элемент мерцанием 1.2с — мягкий сигнал «вот эта строка».
 * Без зависимости от Tailwind — inline-стили, чтобы не плодить kebab-классы.
 */
export function flashAnchor(el: HTMLElement) {
  el.scrollIntoView({ behavior: 'smooth', block: 'center' })
  const prev = el.style.boxShadow
  el.style.transition = 'box-shadow 0.3s ease'
  el.style.boxShadow = 'inset 0 0 0 2px #fbbf24' // amber-400
  window.setTimeout(() => {
    el.style.boxShadow = prev
  }, 1200)
}

/** Из нижней таблицы (клик ⚠) → к строке в блоке «Результат распознавания». */
export function jumpToSourceLine(lineNum: number) {
  const el = document.getElementById(`parsed-line-${lineNum}`)
  if (el) flashAnchor(el)
}

/** Из верхнего блока (клик (N)) → к строке в таблице позиций. */
export function jumpToItemRow(lineNum: number) {
  const el = document.getElementById(`item-row-${lineNum}`)
  if (el) flashAnchor(el)
}
